import { render, staticRenderFns } from "./RechercheFormation.vue?vue&type=template&id=38464734"
import script from "./RechercheFormation.vue?vue&type=script&lang=js"
export * from "./RechercheFormation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports